export default __webpack_public_path__ + "bcdcaacc09faa51f76364888f2b3702d.svg";